import React, { useEffect, useState } from 'react';
import { List, Box, ListItemIcon, ListItemButton, ListItemText, Typography, Collapse } from '@mui/material';
import { 
  ExpandLess, ExpandMore, Settings, Business, AccountCircle, Build, AccountTree, 
  StackedLineChart, LibraryBooks, Inventory, AttachMoney, Flag, Assignment, 
  CurrencyExchange, CreditScore, PriceCheck 
} from '@mui/icons-material';
import { useLocation, NavLink as RouterLink } from 'react-router-dom';

const ICONS = { user: <AccountCircle />, project: <AccountTree />, goal: <Flag />, order: <Assignment />, sales: <AttachMoney />, bond: <CurrencyExchange />, tech: <Build />, eis: <LibraryBooks />, statistics: <StackedLineChart />, product: <Inventory />, partner: <Business />, common: <Settings />, cost: <PriceCheck />, budget: <CreditScore /> };

const getTitleIcon = (iconName) => ICONS[iconName] || '';

const MenuItem = ({ menu, handleDrawerClose }) => {
  const { pathname } = useLocation();

  // [핵심 수정] link가 'mnginfo'인 경우 항상 펼침 모드로 설정
  const isAlwaysOpen = menu.link === 'mnginfo';

  const isChildActive = menu.items?.some(item => 
    pathname === `/${item.link}` || pathname.startsWith(`/${item.link}/`)
  );

  // mnginfo이거나 하위 메뉴가 활성 상태일 때 초기값 true
  const [open, setOpen] = useState(isAlwaysOpen || isChildActive);

  useEffect(() => {
    // mnginfo가 아닐 때만 경로 변화에 따라 자동으로 여닫힘 처리
    if (!isAlwaysOpen) {
      if (isChildActive) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    }
  }, [pathname, isChildActive, isAlwaysOpen]); 

  const handleClick = () => {
    // mnginfo 메뉴는 클릭해도 닫히지 않도록 방어
    if (!isAlwaysOpen) {
      setOpen(!open);
    }
  };

  return (
    <Box>
      <ListItemButton 
        onClick={handleClick} 
        sx={{ 
          borderRadius: '4px', 
          mx: 1, 
          my: 1, 
          px: 1,
          // 항상 열려있는 메뉴는 클릭 커서나 배경색 유지 등 스타일 조정 가능
          cursor: isAlwaysOpen ? 'default' : 'pointer'
        }}
      >
        {menu.icon && <ListItemIcon>{getTitleIcon(menu.icon)}</ListItemIcon>}
        <ListItemText primary={<Typography variant="subtitle2" component="div" sx={{ whiteSpace: 'pre-line' }}>{menu.title}</Typography>} />
        {/* mnginfo 메뉴는 열고 닫는 화살표 아이콘을 표시하지 않음 */}
        {menu.items && !isAlwaysOpen && (open ? <ExpandLess /> : <ExpandMore />)}
      </ListItemButton>

      {menu.items && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {menu.items.map((item, index) => (
              <ListItemButton
                key={index} 
                component={RouterLink} 
                to={item.link} 
                end 
                onClick={handleDrawerClose}
                sx={{ borderRadius: '4px', mx: 1, px: 1, paddingLeft: '56px' }}
                style={({ isActive }) => ({ 
                  background: isActive ? '#37474f' : '', 
                  color: isActive ? '#fff' : '' 
                })}
              >
                <ListItemText primary={<Typography sx={{ whiteSpace: 'pre-line' }} variant="body2" component="div">{item.title}</Typography>} />
              </ListItemButton>
            ))}
          </List>
        </Collapse>
      )}
    </Box>
  );
};

export default MenuItem;
